import React from 'react';
import { cx } from '../cx';

// D-09 §15.2 — Switch (.switch > input[checkbox] + .track)
export type SwitchProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function Switch({ className = '', ...props }: SwitchProps) {
  return (
    <label className={cx('switch', className)}>
      <input type="checkbox" {...props} />
      <span className="track" />
    </label>
  );
}
